module.exports = new __parcel__URL__("user.8368a86a.avif").toString();